module.exports = __webpack_public_path__ + "static/img/videoinicialposter.74252b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoinicialposter.jpg
// module id = 869
// module chunks = 2 3 4 5